/**
 * A sentence ending in a unit label that has its own dot („szt.”) must not end
 * with „szt..”. Single home for the Polish messages that interpolate a quantity
 * at the end of a sentence (review 2026-10-06).
 */
export function singleFinalDot(text: string): string {
  return text.replace(/\.\.$/, '.');
}
